/**
 * Toc
 */
import React from 'react';
import clsx from 'clsx';
import Scrollspy from 'react-scrollspy';
var renderChildren = function (children) {
    return React.Children.map(children, function (child, index) { return (React.createElement("li", { className: "pl-4 border-l-2 text-p toc-li border-greyLight py-1", key: index }, React.cloneElement(child, child.props || {}))); });
};
/** Displays a Table of contents (TOC) */
var Toc = function (_a) {
    var heading = _a.heading, className = _a.className, children = _a.children, _b = _a.headingLevel, headingLevel = _b === void 0 ? 'h2' : _b, items = _a.items, _c = _a.sticky, sticky = _c === void 0 ? false : _c;
    var Heading = headingLevel;
    return (React.createElement("div", { className: clsx(className, sticky && 'sticky toc'), "data-cid": "Toc" },
        React.createElement(Heading, { className: "font-semibold text-h4 mb-2" }, heading),
        React.createElement(Scrollspy, { items: items, currentClassName: "is-current", offset: -35 }, renderChildren(children))));
};
export default Toc;
